export default function ProductCoverageLength() {
    return [
      { label: '10 Years', value: '10' },
      { label: '', value: '15' },
      { label: '', value: '20' },
      { label: '30 Years', value: '30' },
    ];
  }
  


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/CoverageLengths/ProductCoverageLength.js